import { MemoizedSelector, MemoizedSelectorWithProps, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { LoaderError } from '../../../model';
import { PyStateUtils } from '../../../state/utils';
import { StateWithUser, StockInfoDetailsState, UserState } from '../user-state';
import { getUserState } from './feature.selector';

export const getStockInfoDetails: MemoizedSelector<
  StateWithUser,
  StateUtils.EntityLoaderState<StockInfoDetailsState>
> = createSelector(getUserState, (state: UserState) => state && state.stockInfoDetails);

export const getStockInfoDetailsState: MemoizedSelectorWithProps<StateWithUser, any, StockInfoDetailsState | undefined> =
  createSelector(getStockInfoDetails, (state: StateUtils.EntityLoaderState<StockInfoDetailsState>, props) =>
    StateUtils.entityValueSelector(state, props.key)
  );

export const getStockInfoDetailsLoaderState: MemoizedSelectorWithProps<
  StateWithUser,
  any,
  StateUtils.LoaderState<StockInfoDetailsState>
> = createSelector(getStockInfoDetails, (state: StateUtils.EntityLoaderState<StockInfoDetailsState>, props) =>
  PyStateUtils.entityLoaderStateSelector(state, props.key)
);

export const getStockInfoDetailsStateLoading: MemoizedSelectorWithProps<StateWithUser, any, boolean> = createSelector(
  getStockInfoDetails,
  (state: StateUtils.EntityLoaderState<StockInfoDetailsState>, props) => StateUtils.entityLoadingSelector(state, props.key)
);

export const getStockInfoDetailsStateSuccess: MemoizedSelectorWithProps<StateWithUser, any, boolean> = createSelector(
  getStockInfoDetails,
  (state: StateUtils.EntityLoaderState<StockInfoDetailsState>, props) => StateUtils.entitySuccessSelector(state, props.key)
);

export const getStockInfoDetailsStateError: MemoizedSelectorWithProps<StateWithUser, any, LoaderError | undefined> =
  createSelector(getStockInfoDetails, (state: StateUtils.EntityLoaderState<StockInfoDetailsState>, props) =>
    PyStateUtils.entityErrorDetailsSelector(state, props.key)
  );
